var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-wave"},_vm._l((5),function(n){return _c('div',{staticClass:"sk-rect",class:("sk-rect-" + n)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }